import { render, staticRenderFns } from "./ChainForm.vue?vue&type=template&id=51fe8630&scoped=true&"
import script from "./ChainForm.vue?vue&type=script&lang=js&"
export * from "./ChainForm.vue?vue&type=script&lang=js&"
import style0 from "./ChainForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChainForm.vue?vue&type=style&index=1&id=51fe8630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe8630",
  null
  
)

export default component.exports